/**
 * 도메인 race 패배 안내 — FE-W-03 skeleton (FE-W-09 에서 본문 확장).
 *
 * 시나리오: 두 사용자가 동시에 같은 도메인으로 가입 시도 → 한 명만 통과,
 *          다른 한 명이 본 페이지로 navigate.
 */

import { useSyncExternalStore } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { tOnb, getOnboardingLang, subscribeOnboardingLang } from '../../lib/onboarding-i18n';

export function OnboardingRaceRejectedPage() {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  const navigate = useNavigate();
  return (
    <div role="alert" aria-live="assertive">
      <h2 className="onboarding-step__heading">{tOnb('onboarding.race.heading')}</h2>
      <p className="onboarding-step__subheading">
        {tOnb('onboarding.race.line1')}<br />
        {tOnb('onboarding.race.line2')}
      </p>
      <div className="onboarding-step__actions">
        <button
          type="button"
          className="onboarding-step__button onboarding-step__button--primary"
          onClick={() => navigate('/onboarding/domain', { replace: true })}
        >
          {tOnb('onboarding.race.btn_retry_diff_domain')}
        </button>
        <Link
          to="/login"
          className="onboarding-step__button onboarding-step__button--secondary"
          style={{ textAlign: 'center', textDecoration: 'none', display: 'inline-block' }}
        >
          {tOnb('onboarding.btn.to_login')}
        </Link>
      </div>
    </div>
  );
}
